import * as React from 'react';
import { ComponentProps, ButtonTertiary } from 'ui';
import { withOpenState, OpenStateInjectedProps } from 'ui/common/enhancers/with-open-state';
import { ModalWrapper } from 'app/components/modal-wrapper/modal-wrapper';
import styles from './link-to-modal-view.scss';
import { ModalSize } from 'app/components/constants';

import type { JSX } from "react";

interface LinkToModalViewProps {
  textHeaderTitle?: string;
  textHeaderInfo?: string;
  textDone?: string;
  content?: JSX.Element;
  icon?: JSX.Element;
}

export type LinkToModalViewComponentProps = ComponentProps & OpenStateInjectedProps & LinkToModalViewProps;

class LinkToModalViewComponent extends React.PureComponent<LinkToModalViewComponentProps> {

  private closeModal = () => {
    const {isOpen, close} = this.props;

    isOpen && close();
  };

  public render() {
    const {
      label,
      isOpen,
      open,
      textHeaderTitle,
      textHeaderInfo,
      textDone,
      content,
      icon
    } = this.props;    

    const linkButton = 
      <ButtonTertiary onClick={open} className={styles.linkButton}>
        <span className={styles.icon}>{icon}</span> 
        <span className={styles.text}>{label?.text}</span>
      </ButtonTertiary>;
    
    const modalView =
      <ModalWrapper
        headerTitle={textHeaderTitle}
        headerInfo={textHeaderInfo}
        btnTitle={textDone}
        onClose={this.closeModal}
        onDone={this.closeModal}
        size={ModalSize.large}>          
          {content}          
      </ModalWrapper>;

    return (
      <div className={`${styles.linkButtonWrapper}`}>
        {linkButton}
        {isOpen && modalView}
      </div>
    );
  }
}

const c = withOpenState()(LinkToModalViewComponent);

export { c as LinkToModalView };
